import api from './axios';
import { ApiResponse } from '../types';

export type ContactPayload = {
  full_name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
};

export type ContactResponse = {
  id: string;
};

export const submitContact = async (payload: ContactPayload) => {
  const response = await api.post<ApiResponse<ContactResponse>>('/api/v1/contact-us', payload);
  return response.data;
};


